import { Box } from '@mui/material';
import { Product } from '../../../../products/api/types';

interface ProductLabelProps {
    product: Product;
}

const ProductLabel = ({ product }: ProductLabelProps) => {
    return <Box sx={{ display: 'flex', color: 'common.black', gap: '6px' }}>{product.shortName}</Box>;
};

export default ProductLabel;
